import React from 'react';
import { graphql, compose } from 'react-apollo';
import { ToastContainer } from 'react-toastr';
import Banner from '../../../components/Banner/index';
import Footer from '../../../components/Footer/index';
import MY_DETAILS_QUERY from '../../../graphql/MyDetails';
import EDIT_MY_DETAILS_MUTATION from '../../../graphql/EditMyDetails';
import Sidebar from '../../../components/Sidebar/index';
import AdminForm from './AdminForm';
import ArtistForm from './ArtistForm';
import { IsArtist } from '../../../utils/Roles';

class EditProfile extends React.Component {
  componentWillMount() {
    if (localStorage.getItem('escenaToken') === null) {
      this.props.history.push('/login');
    }
  }

  onLogout = () => {
    this.props.history.push('/login');
  };

  handleUserUpdate = (user) => {
    const { mutate } = this.props;
    mutate({
      variables: user,
    })
      .then(() => {
        this.toastr.success('Información actualizada correctamente');
      })
      .catch(() => {
        this.toastr.error('Ocurrió un problema al modificar tu  información');
      });
  };

  render() {
    const isArtist = IsArtist();
    return (
      <div>
        <ToastContainer
          ref={(ref) => { this.toastr = ref; }}
          className="toast-top-right"
        />
        <Banner />
        <div className="my-propertiess">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-12">
                <Sidebar active="personal" onLogout={this.onLogout} />
              </div>

              <div className="col-lg-9 col-md-9 col-sm-12 new-form-container">
                <h1 className="heading">Información personal</h1>
                <div className="submit-address">
                  {
                    (this.props.user && isArtist) && (
                      <ArtistForm
                        onEditUser={this.handleUserUpdate}
                        user={this.props.user}
                      />
                    )
                  }
                  {
                    (this.props.user && !isArtist) && (
                      <AdminForm
                        onEditUser={this.handleUserUpdate}
                        user={this.props.user}
                      />
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const withMutation = graphql(EDIT_MY_DETAILS_MUTATION);

const withDetails = graphql(MY_DETAILS_QUERY, {
  options: () => ({
    fetchPolicy: 'network-only',
  }),
  props: ({ data }) => ({
    loading: data.loading,
    user: data.myDetails,
  }),
});
export default compose(withDetails, withMutation)(EditProfile);



// WEBPACK FOOTER //
// ./src/containers/Profile/EditProfile/index.js